import {Injectable, OnInit} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {FormStatusItem, SdetExpressInterface, SdetInterface, SdetSello} from "../components/interfaces/sdet.interface";
import {
    PagarTramiteInterface,
    SDetRq,
    TramiteItem,
    VaciarCarritoInterface
} from "../components/interfaces/tramites.interface";
import {CargoItem} from "../../interfaces/pagos.interface";
import {environment} from "../../../../environments/environment.development";
import {LoginServices} from "../../../auth/login/services/login.service";
import {SolicitudRequisitoItem} from "../../../shared/interfaces/shared-interface";
import Swal from "sweetalert2";
import {throwError} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";

let apiVucUrl = environment.apiVucUrl

@Injectable({
    providedIn: 'root'
})
export class SdetTramiteService implements OnInit {
    constructor(private http: HttpClient, private loginServices: LoginServices, public router: Router, private route: ActivatedRoute,) {
    }

    ngOnInit(): void {
        console.log("ngOnInit ->SdetTramiteService");
    }

    /**
     * Agrega un nuevo servicio al carrito.
     */
    createSdet(sdet: SdetInterface) {
        console.log(`createSdet ->${JSON.stringify(sdet)}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet`;
        return this.http.post<SdetInterface>(url, sdet, {observe: 'response'});
    }
    /**
     * Crea una solicitud express de forma automatica
     */
    createSdetExpress(sdetExpress: SdetExpressInterface) {
        console.log(`createSdetExpress ->${JSON.stringify(sdetExpress)}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet-express`;
        let id: number | SdetExpressInterface;
        this.http.post<SdetExpressInterface>(url, sdetExpress, {observe: 'response'})
            .subscribe({
                next: (resp) => {
                    if (resp) {
                        if (resp.status == 200 || resp.status == 201 || resp.status == 204) {
                            id = resp.body ? resp.body : 0;
                        }
                    }
                },
                error: (error) => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.error.mensaje,
                        showConfirmButton: true,
                        timer: 5000
                    })
                    return throwError(() => error);
                }, complete: () => {
                    if (id) {
                        this.router.navigate(['/users/pagos/tramites', id])
                            .then(() => {
                                console.log(`tramites done` + JSON.stringify(this.route.snapshot.queryParams));
                            });
                        Swal.fire({
                            title: "Procesado",
                            text: "Solicitud creada con exito",
                            icon: "success"
                        });
                    }
                }
            });
    }


    /**
     * Actualiza un servicio existente del carrito.
     *
     *  eventType permite los siguientes valores: <br/><b>['', 'update', 'iniciar-form']</b>
     */
    updateStatusSdet(sdet: SdetInterface, eventType?: string) {
        console.log(`updateStatusSdet -> ${JSON.stringify(sdet)}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet/estado?event_type=${eventType ? eventType.toString() : ''}`;
        return this.http.put<SdetInterface | FormStatusItem[]>(url, sdet, {observe: 'response'});
    }

    /**
     * Actualiza un servicio existente del carrito.
     *
     *  eventType permite los siguientes valores: <br/><b>['', 'update', 'iniciar-form']</b>
     */
    updateStatusFullSdet(sdet: SdetInterface, eventType: string) {
        console.log(`updateStatusFullSdet -> sdet:${JSON.stringify(sdet)}, eventType:${eventType}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet/estado?event_type=${eventType ? eventType.toString() : ''}`;
        return this.http.put<SdetInterface | FormStatusItem[]>(url, sdet, {observe: 'response'});
    }

    /**
     * Actualiza un servicio existente del carrito cuando el proyecto ya esta asignado y fue
     * creado de forma seleccion libre o tipo de flujo 2
     */
    updateStatusSdetAsignacion(sdet: SdetInterface) {
        console.log(`updateStatusSdetAsignacion -> sdet:${JSON.stringify(sdet)}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet/estado-asignacion`;
        return this.http.put<SdetInterface>(url, sdet, {observe: 'response'});
    }

    /**
     * Procesa el pago y sincroniza estados, tarifario y pago en todos los servicios existentes del carrito.
     */
    pagoDot(items: TramiteItem[], pago: CargoItem, usuario: string | null | undefined) {
        console.log(`pagoDot ->items:${JSON.stringify(items.length)}, usuario: ${usuario}`);
        let finalItems: PagarTramiteInterface[] = []
        items.forEach(i => {
            let i2: PagarTramiteInterface = {
                codigoInstitucion: parseInt(i.codigoInstitucion, 10),
                creadoPor: usuario,
                idTramite: parseInt(i.idTramite, 10),
                idFase: 0,
                idProyecto: i.idProyecto ? i.idProyecto : 0,
                pago: pago
            }
            finalItems.push(i2);
            console.log("finalItems ->items:" + JSON.stringify(finalItems));
        })
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet/registrar-pago`;
        return this.http.post<[]>(url, finalItems, {observe: 'response'});
    }

    /**
     *Elimina del carrito los items especificados.
     */
    vaciarCarrito(items: TramiteItem[], usuario: string | null | undefined) {
        let ids: number[] = items.map(i => parseInt(i.idTramite, 10))
        let pivotItem = items[0];
        console.log(`items     :${JSON.stringify(items)}`);
        console.log(`pivotItem : ${JSON.stringify(pivotItem)}`);
        let vc: VaciarCarritoInterface = {
            codigoInstitucion: parseInt(pivotItem.codigoInstitucion, 10),
            creadoPor: usuario,
            idFase: 0,
            idProyecto: pivotItem.idProyecto ? pivotItem.idProyecto : 0,
            idSolicitud: pivotItem.idSolicitud ? pivotItem.idSolicitud : 0,
            idsTramites: ids
        }
        console.log(JSON.stringify(vc));
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet/vaciar-carrito`;
        return this.http.post<[]>(url, vc, {observe: 'response'});
    }

    obtenerSdetItem(idProyecto: string | "" | null, idTramite: string, idSolicitud?: string | null) {
        console.log(`obtenerSdetItem ->idProyecto=${idProyecto}, idTramite: ${idTramite}`);
        let idprj: number | 0 = 0;
        if (idProyecto !== null && idProyecto !== '' && idProyecto !== undefined && idProyecto !== 'undefined' && idProyecto !== 'null') {
            idprj = parseInt(idProyecto);
        }
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet?idProyecto=${idprj}&idTramite=${idTramite ? parseInt(idTramite) : 0}`;
        return this.http.get<TramiteItem>(url, {observe: 'response'});
    }

    obtenerSdetItemAsignacionAutomatica(idProyecto: string | null, idTramite: string, idSolicitud?: string | null) {
        const url = apiVucUrl + 'api/v1.0/registro-profesionales/asignacion';

        // Convertir los valores a número, usando 0 como valor por defecto si no están definidos
        const body = {
            idProyecto: idProyecto ? parseInt(idProyecto) : 0,
            idTramite: idTramite ? parseInt(idTramite) : 0,
            idSolicitud: idSolicitud ? parseInt(idSolicitud) : 0
        };

        return this.http.post<boolean>(url, body, { observe: 'response' });
    }

    /**
     * Actualiza el estado archivo de los requisitos existente del por proyecto.
     * En la tabla solicitud detalle rq
     */
    completarSolicitudDetalleRq(usuario: string, idRequisito: number, idProyecto: number) {
        const sdrq: SDetRq = {
            usuario: usuario,
            idRequisito: idRequisito,
            idProyecto: idProyecto,
        };
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/requisito/completar`;
        return this.http.put<any>(url, sdrq, {observe: 'response'});
    }

    /**
     * Actualiza el estado de los requisito opcionales o obligatorios considerado para el FU
     * En la tabla solicitud detalle rq
     */
    updateEstadoOpcionalRq(idProyecto: number) {
        const sdrq: SDetRq = {
            usuario: this.loginServices.session()?.perfil.usuario,
            idRequisito: 0,
            idProyecto: idProyecto,
        };
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/requisito/actualizar-opcional`;
        return this.http.put<any>(url, sdrq, {observe: 'response'});
    }

    actualizar(item: SolicitudRequisitoItem) {
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/requisito`;
        return this.http.put<SdetInterface>(url, item, {observe: 'response'});
    }

    /**
     * Obtiene tramite con la url del formulario que correspondiente.
     */
    initFormSdet(sdet: SdetInterface) {
        console.log(`initFormSdet -> sdet:${JSON.stringify(sdet)}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet/initFormSdet`;
        return this.http.post<SdetInterface | FormStatusItem[]>(url, sdet, {observe: 'response'});
    }

    createSdetSello(sdetSello: SdetSello) {
        console.log(`createSdetSello ->${JSON.stringify(sdetSello)}`);
        let url = apiVucUrl + `api/v1.0/solicitud/detalles/sdet-sello`;
        return this.http.post<SdetInterface>(url, sdetSello, {observe: 'response'});
    }

}
